<template>
  <div id="contenedor-contrato-editar-actividad">
    <v-form v-model="formularioValido" ref="editarContratoActividad">
      <v-card>
        <v-card-title class="secondary--text">
          Editar actividad
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <date-picker
              v-model="actividad.fecha"
              label="Fecha"
              cols="6"
            >
            </date-picker>
            <custom-text-area
              v-model="actividad.descripcion"
              cols="12"
              label="Descripción"
              rows="4"
            >
            </custom-text-area>
            <custom-select
              cols="4"
              v-model="actividad.verificacionSeguridad"
              label="Verificación de seguridad"
              :items="selectItems"
              item-text="text"
              item-value="value"
              prepend-inner-icon="mdi-shield-check-outline"
            >
            </custom-select>
            <custom-select
              cols="4"
              v-model="actividad.higieneLimpiezaTrabajos"
              label="Higiene y limpieza"
              :items="selectItems"
              item-text="text"
              item-value="value"
              prepend-inner-icon="mdi-broom"
            >
            </custom-select>
            <custom-select
              cols="4"
              v-model="actividad.inventarioInsumosPresentes"
              label="Inventario de insumos"
              :items="selectItems"
              item-text="text"
              item-value="value"
              prepend-inner-icon="mdi-bulldozer"
            >
            </custom-select>
          </v-row>
          <v-divider></v-divider>
          <!-- Fotos de la actividad -->
          <div id="contenedor-album-fotografico">
            <v-row>
              <!-- Listado de imagenes -->
              <template v-for="(imagen, index) in imagenes">
                <template>
                  <v-col cols="auto" class="pa-1" :key="`imagen-${index}`">
                    <v-img
                      :src="imagen"
                      height="180"
                      width="180"
                      contain
                      class="blue-grey darken-4"
                    >
                      <div class="contenedor-imagenes-remover-imagen">
                        <v-btn small icon dark @click="removerImagen(index)">
                          <v-icon>
                            mdi-close-circle
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-img>
                  </v-col>
                </template>
              </template>
              <!-- Seleccionar imagen -->
              <v-col cols="auto">
                <div class="contenedor-imagenes-agregar" @click="$refs.seleccionarAnexo.click()">
                  <v-img src="@/assets/add-img-img.png" contain height="100" width="100"> </v-img>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarContratoActividad"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
    <input
      type="file"
      ref="seleccionarAnexo"
      id="anexo"
      class="d-none"
      accept="image/jpeg, image/png, image/bmp"
      multiple
      @change="preCargarImagenes"
    />
  </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixDiarioActividades from './mixDiarioActividades';

export default {
  name: 'ContratoEditarActividad',
  mixins: [mixDiarioActividades],
  props: {
    actividadContratoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    DatePicker,
    CustomSelect,
    CustomTextArea,
    CustomButton,
  },
  data() {
    return {
      selectItems: [
        { value: 1, text: 'BIEN' },
        { value: 2, text: 'REGULAR' },
        { value: 3, text: 'MAL' },
      ],
      // id contrato para que no de error query de frentes de contrato del mix
      idContrato: this.actividadContratoEditar.idContrato,
      formularioValido: false,
      enviandoFormulario: false,
      imagenes: [],
      actividad: {
        idContratoFrente: this.actividadContratoEditar.idContratoFrente,
        descripcion: this.actividadContratoEditar.descripcion,
        fecha: this.actividadContratoEditar.fecha,
        imagenes: this.actividadContratoEditar.imagenes,
        verificacionSeguridad: this.actividadContratoEditar.verificacionSeguridad,
        higieneLimpiezaTrabajos: this.actividadContratoEditar.higieneLimpiezaTrabajos,
        inventarioInsumosPresentes: this.actividadContratoEditar.inventarioInsumosPresentes,
      },
    };
  },
  mounted() {
    this.crearUrlDeLasImagenesSeleccionadas();
  },
  methods: {
    preCargarImagenes() {
      const { imagenes } = this.actividad;
      // get las fotos
      const fileInput = document.getElementById('anexo');
      imagenes.push(...fileInput.files);

      for (let i = 0; i < fileInput.files.length; i += 1) {
        const url = URL.createObjectURL(fileInput.files[i]);
        this.imagenes.push(url);
      }
    },
    crearUrlDeLasImagenesSeleccionadas() {
      let { imagenes } = this.actividad;
      if (typeof imagenes === 'string') {
        imagenes = JSON.parse(imagenes);
      }
      for (let i = 0; i < imagenes.length; i += 1) {
        if (typeof imagenes[i] === 'string') {
          const url = `${this.$urlFileServer}/${imagenes[i]}`;
          this.imagenes.push(url);
        } else {
          const url = URL.createObjectURL(imagenes[i]);
          this.imagenes.push(url);
        }
      }
    },
    removerImagen(index) {
      this.imagenes.splice(index, 1);
      this.actividad.imagenes.splice(index, 1);
    },
    limpiarFormulario() {
      this.$refs.editarContratoActividad.reset();
      this.imagenes = [];
      this.actividad.esProblema = false;
      this.actividad.imagenes = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor-imagenes-vista-previa {
  position: relative;
}
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagenes-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: 0.5rem;
  cursor: pointer;
}
.contenedor-imagenes-agregar:hover {
  border: 2px solid #ccc;
}
</style>
